import AdSensePush from "@/components/AdSensePush.tsx";
import {config} from "@/config/config.ts";
import {useMinWidth} from "@/hooks/useMinWidth.ts";

/**
 * Fixed AdSense rails pinned to both page gutters. Shown only on wide screens
 * (>=1850px) where there's room beside the centred container, so they never
 * overlap the content. Renders nothing when ads are disabled.
 *
 * The <ins> is only mounted when the viewport is actually wide enough — a hidden rail left in the
 * DOM would steal the positional `adsbygoogle.push({})` meant for the visible content banner.
 */
export default function AdRails({slot = config.adsenseRegistrationSlot, labelClassName = "text-white/40"}: {slot?: string; labelClassName?: string}) {
    const wide = useMinWidth(1850);

    if (!config.adsenseEnabled || !wide) {
        return null;
    }

    return <>
        {(["left", "right"] as const).map((side) => (
            <aside key={side} aria-label="Advertisement"
                   className={`fixed ${side === "left" ? "left-4" : "right-4"} top-1/2 z-20 block w-[160px] -translate-y-1/2`}>
                <div className={`mb-1 text-center text-[10px] uppercase tracking-[0.2em] ${labelClassName}`}>Advertisement</div>
                <AdSensePush>
                    <ins
                        className="adsbygoogle"
                        style={{display: "block", width: 160, minHeight: 600}}
                        data-ad-client={config.adsenseClient}
                        data-ad-slot={slot}
                        data-ad-format="auto"
                        data-full-width-responsive="false"
                    />
                </AdSensePush>
            </aside>
        ))}
    </>;
}
